export const SUBMIT_PROCESS_STATEMENT_REQUEST = 'SUBMIT_PROCESS_STATEMENT_REQUEST';

export const submitProcessStatementRequest = ( id, { submitInformation } ) => ({
    type: SUBMIT_PROCESS_STATEMENT_REQUEST,
    payload: {
        id,
        submitInformation
    }
});
